import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from "./App";
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);

// If REACT_APP_DEBUG, then report web vitals
if (process.env.NODE_ENV === 'development') {
    reportWebVitals(console.log);
}

// TODO index.tsx:
//  Check for HTML element exists (#root)
